import _ from 'lodash'
import moment from 'moment'

import orderActions, {
  ORDER_UPDATE_REQUEST,
  ORDER_UPDATE_FAILURE,
  ORDER_UPDATE_SUCCESS,
  ORDER_UPDATE_NOTE_REQUEST,
  ORDER_UPDATE_NOTE_FAILURE,
  ORDER_UPDATE_NOTE_SUCCESS,
  ORDER_LIST_DASHBOARD_SUCCESS,
  UPDATE_ORDER_DASHBOARD_FILTERS,
  CLEAN_ORDER_FILTER,
  SHOW_TOAST,
  HIDE_TOAST
} from '../../actions/orderActions'
import {
  ORDER_MAP_CLICK,
  ORDER_DETAIL_CLOSE,
  COURIER_MAP_CLICK,
  DELETE_COURIER_ACTIVE,
  ORDER_CLICK_SUCCESS,
  TRACKER_REQUEST,
  TRACKER_SUCCESS,
  TRACKER_FAILURE,
  USE_TRACKER_REQUEST,
  USE_TRACKER_SUCCESS,
  USE_TRACKER_FAILURE,
  DASHBOARD_CLEANUP,
  TOGGLE_COURIER_ROUTE,
  ROUTE_ORDER_SELECT
} from '../../actions/dashboardActions'
import { ADMIN_CITIES_SUCCESS } from '../../actions/all/adminCitiesActions'
import {
  COURIER_LIST_SUCCESS,
  COURIER_LIST_REQUEST,
  UPDATE_COURIER_FILTERS,
  COURIER_ROUTE_PLAN_REQUEST,
  COURIER_ROUTE_PLAN_SUCCESS,
  COURIER_ROUTE_PLAN_FAILURE
} from '../../actions/courierActions'
import { WS_MESSAGE } from '../../actions/wsActions'
import { defaultMapCenter } from '../../utils/variables'
import { getPosition } from '../../utils'

function getCoordinates(data) {
  if (!data || !Array.isArray(data.cities)) return ''
  const currentCity = data.cities.find(
    city => city.city_id === data.current_city_id
  )
  return currentCity?.latlon || ''
}

export default function reducer(
  state = {
    needRefresh: false,
    orderIsUpdating: false,
    orderData: {},
    data: {},
    orderErrors: false,
    courierIsFetching: false,
    courierData: [],
    courierErrors: false,
    mapCenter: null,
    zoom: 13,
    orderDetailVisibility: false,
    orderMapVisibility: false,
    orderActive: false,
    notes: {},
    orderDelayed: 0,
    orderNotification: false,
    courierNotification: false,
    courierDetailVisibility: false,
    courierMapVisibility: true,
    courierActive: null,
    courierRouteVisible: false,
    routeOrderActive: null,
    routePlan: null,
    routePlanFetching: false,
    orderFilters: {
      page: 1,
      group: 'pending',
      created_at_0: moment().startOf('day').toISOString(),
      created_at_1: null,
      courier: ''
    },
    useTracker: false,
    toast: {
      visible: false,
      message: '',
      type: 'error', // puede ser 'info', 'success', 'warning', 'error'
      showForcedBtn: false,
      orderId: null,
      courierId: null
    },
    lastWSMessage: null
  },
  action
) {
  switch (action.type) {
    case ORDER_UPDATE_REQUEST:
      return Object.assign({}, state, {
        orderIsUpdating: true
      })

    case ORDER_UPDATE_SUCCESS:
      return Object.assign({}, state, {
        orderIsUpdating: false,
        orderActive: action.data,
        orderDataUpdate: Object.assign(state.orderData, {
          results: _.unionBy([action.data], state.orderData.results, 'id')
        })
      })

    case ORDER_UPDATE_FAILURE:
      return Object.assign({}, state, {
        orderIsUpdating: false,
        orderErrors: action.data
      })

    // Manejo de toast para el forzado de asignación
    case SHOW_TOAST:
      return {
        ...state,
        toast: {
          visible: true,
          message: action.payload.message,
          type: action.payload.type || 'info',
          showForcedBtn: action.payload.showForcedBtn || false,
          orderId: action.payload.orderId,
          courierId: action.payload.courierId
        }
      }

    case HIDE_TOAST:
      return {
        ...state,
        toast: {
          ...state.toast,
          visible: false
        }
      }

    case COURIER_ROUTE_PLAN_REQUEST:
      return { ...state, routePlan: null, routePlanFetching: true }

    case COURIER_ROUTE_PLAN_SUCCESS:
      return { ...state, routePlan: action.data, routePlanFetching: false }

    case COURIER_ROUTE_PLAN_FAILURE:
      return { ...state, routePlan: null, routePlanFetching: false }

    case DASHBOARD_CLEANUP:
      return Object.assign({}, state, {
        useTracker: false,
        isPolling: false,
        mapCenter:
          JSON.parse(localStorage.getItem('adminCity')) || defaultMapCenter,
        courierData: [],
        orderActive: false,
        courierActive: null,
        courierRouteVisible: false,
        routeOrderActive: null,
        routePlan: null,
        routePlanFetching: false,
        orderDetailVisibility: false,
        orderMapVisibility: false
      })

    // ws Events
    case WS_MESSAGE: {
      // wsState incluye siempre el último mensaje para que los consumidores
      // (p.ej. useOrderReport) puedan reaccionar a cualquier evento WS
      const wsState = { ...state, lastWSMessage: action.data }
      if (action.data.stream === 'eta') {
        // TODO: implementar lógica de ETA
      }
      if (
        action.data.stream === 'order' ||
        action.data.stream === 'destination'
      ) {
        const { payload } = action.data
        const datos = payload?.data || {}
        const demorados = datos.delayed_orders?.total_delayed_orders

        /**
         * El contador de demorados y el aviso de cambio son cosas distintas.
         *
         * Antes el primero salía por un `return` propio y se comía al segundo:
         * un mensaje que trajera `delayed_orders` actualizaba el contador y
         * dejaba `orderNotification` sin tocar. Hoy nadie lee esa bandera —el
         * repintado va por `lastWSMessage`—, así que esto no cambia lo que se
         * ve; se corrige para que el estado no mienta sobre lo que pasó.
         */
        return {
          ...wsState,
          ...(demorados ? { orderDelayed: demorados } : {}),
          orderNotification: true
        }
      }
      if (action.data.stream === 'courier' && state.courierData.length) {
        const { payload } = action.data
        const index = state.courierData.findIndex(x => x.id === payload.id)
        const courier = state.courierData.find(x => x.id === payload.id)
        if (courier) {
          const { position, ...rest } = payload.data
          const updatedCourier = {
            ...courier,
            ...rest,
            id: payload.id
          }
          const courierData = [
            ...state.courierData.slice(0, index),
            updatedCourier,
            ...state.courierData.slice(index + 1)
          ]

          if (!updatedCourier.is_online) {
            courierData.splice(index, 1)
          }
          return {
            ...wsState,
            courierData
          }
        }
        return {
          ...wsState,
          courierData: [
            ...state.courierData,
            {
              id: payload.id,
              busy_level: 'free',
              ...payload.data
            }
          ]
        }
      }
      return wsState
    }

    // UI actions
    case ORDER_CLICK_SUCCESS:
      return Object.assign({}, state, {
        orderDetailVisibility: true,
        orderActive: action.data
      })

    case ORDER_MAP_CLICK:
      return Object.assign({}, state, {
        orderDetailVisibility: false,
        orderMapVisibility: true,
        orderActive: action.order,
        mapCenter: getPosition(action.order.destinations[0].latlon)
      })

    case TOGGLE_COURIER_ROUTE: {
      const nextVisible = !state.courierRouteVisible
      if (!nextVisible || !state.routePlan?.destinations?.length) {
        return Object.assign({}, state, {
          courierRouteVisible: nextVisible,
          routeOrderActive: null
        })
      }
      const dests = state.routePlan.destinations
      const lats = dests.map(d => d.lat).filter(Boolean)
      const lngs = dests.map(d => d.lng).filter(Boolean)
      return Object.assign({}, state, {
        courierRouteVisible: nextVisible,
        routeOrderActive: null,
        mapCenter: [
          (Math.min(...lats) + Math.max(...lats)) / 2,
          (Math.min(...lngs) + Math.max(...lngs)) / 2
        ],
        zoom: 13
      })
    }

    case ROUTE_ORDER_SELECT:
      return Object.assign({}, state, {
        routeOrderActive:
          !action.order ||
          (state.routeOrderActive &&
            state.routeOrderActive.id === action.order.id)
            ? null
            : action.order
      })

    case COURIER_MAP_CLICK:
      return Object.assign({}, state, {
        courierDetailVisibility: false,
        courierMapVisibility: true,
        courierActive: action.courier,
        courierRouteVisible: false,
        routePlan: null,
        routePlanFetching: false,
        zoom: 17,
        orderFilters: Object.assign({}, state.orderFilters, {
          courier: action.courier.id,
          group: 'ongoing',
          page: 1
        }),
        mapCenter: action.courier.position.coordinates
      })

    case ORDER_DETAIL_CLOSE:
      return Object.assign({}, state, {
        orderDetailVisibility: false,
        orderMapVisibility: false,
        orderActive: undefined
      })

    case ORDER_LIST_DASHBOARD_SUCCESS:
      return Object.assign({}, state, {
        orderData: action.data,
        needRefresh: false,
        orderNotification: false
      })

    case ORDER_UPDATE_NOTE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })

    case ORDER_UPDATE_NOTE_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        notes: action.data
      })

    case ORDER_UPDATE_NOTE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        errors: action.data
      })

    case UPDATE_ORDER_DASHBOARD_FILTERS:
      return Object.assign({}, state, {
        orderFilters: Object.assign({}, state.orderFilters, action.data),
        needRefresh: true
      })

    case COURIER_LIST_REQUEST:
      return Object.assign({}, state, {
        courierIsFetching: true,
        needRefresh: false,
        courierNotification: false
      })

    case COURIER_LIST_SUCCESS:
      return Object.assign({}, state, {
        data: false,
        courierData: Array.isArray(action.data)
          ? action.data
          : action.data?.results || [],
        courierNotification: false
      })

    case UPDATE_COURIER_FILTERS:
      return Object.assign({}, state, {
        data: false,
        courierData: []
      })

    case CLEAN_ORDER_FILTER:
      return Object.assign({}, state, {
        orderData: {},
        orderFilters: {
          page: 1,
          group: 'pending',
          created_at_0: moment().startOf('day').toISOString(),
          created_at_1: null,
          courier: ''
        }
      })

    case orderActions.ORDER_SETOPTIONS_SUCCESS:
      return Object.assign({}, state, {
        needRefresh: true
      })

    case DELETE_COURIER_ACTIVE:
      return Object.assign({}, state, {
        courierActive: null,
        courierRouteVisible: false,
        routeOrderActive: null,
        routePlan: null,
        routePlanFetching: false,
        orderFilters: Object.assign({}, state.orderFilters, {
          group: 'pending',
          courier: '',
          page: 1
        }),
        mapCenter:
          JSON.parse(localStorage.getItem('adminCity')) || defaultMapCenter,
        zoom: 13
      })

    case TRACKER_REQUEST:
      return Object.assign({}, state, {
        isPolling: true
      })
    case TRACKER_SUCCESS: {
      const currentCouriers = Array.isArray(state.courierData)
        ? state.courierData
        : []
      const updateCouriersData = currentCouriers.map(el => {
        const courier = action.data.find(curr => curr.id === el.id)
        if (courier && courier.latitude && courier.longitude) {
          return {
            ...el,
            position: {
              coordinates: [courier.latitude, courier.longitude]
            }
          }
        }
        return el
      })
      return {
        ...state,
        isPolling: false,
        courierData: updateCouriersData
      }
    }
    case TRACKER_FAILURE:
      return Object.assign({}, state, {
        isPolling: false
      })

    case USE_TRACKER_REQUEST:
      return Object.assign({}, state, {
        useTracker: false
      })
    case USE_TRACKER_SUCCESS:
      return Object.assign({}, state, {
        useTracker: action.data.new_tracking_service
      })
    case USE_TRACKER_FAILURE:
      return Object.assign({}, state, {
        useTracker: false
      })

    case ADMIN_CITIES_SUCCESS: {
      const coords = getPosition(getCoordinates(action.data))
      return Object.assign({}, state, {
        mapCenter: coords.length === 2 ? coords : defaultMapCenter
      })
    }

    default:
      return state
  }
}
